import Quagga from '@ericblade/quagga2';
import {Check, Close} from '@mui/icons-material';
import {Box, Button, Grid, Link, Typography} from '@mui/material';
import moment from 'moment';
import React, {useEffect} from 'react';
import Geocode from 'react-geocode';
import {useFormContext, useWatch} from 'react-hook-form';
import {useSelector} from 'react-redux';
import {i18n} from 'src/i18n';
import ArticuloService from 'src/modules/articulo/articuloService';
import authSelectors from 'src/modules/auth/authSelectors';
import {isPlastyvergTenant} from 'src/modules/tarea/dynamicSubsectionPdfGrouping';
import {
  applyArticuloToleranceBoundsForTask,
  applyArticuloToleranceBoundsToEstructura,
  resolvePlastyvergArticuloTitulo,
  resolvePlastyvergArticuloVariant,
} from 'src/modules/tarea/plastyvergArticuloToleranceBounds';
import Storage from 'src/security/storage';
import ActivoAutocompleteFormItem from 'src/view/activo/autocomplete/ActivoAutocompleteFormItem';
import AsignadorFuncionAutocompleteFormItem from 'src/view/asignadorFuncion/autocomplete/AsignadorFuncionAutocompleteFormItem';
import ArticuloAutocompleteFormItem from 'src/view/articulo/autocomplete/ArticuloAutocompleteFormItem';
import {alternativeSelectValue} from 'src/modules/shared/alternativeTreeDisplay';
import {mergeLiteralIntoAlternativas} from 'src/view/modeloFormulario/form/mergeLiteralIntoAlternativas';
import ModeloTareaAutocompleteFormItem from 'src/view/modeloTarea/autocomplete/ModeloTareaAutocompleteFormItem';
import PerfilEmpleadoAutocompleteFormItem from 'src/view/perfilEmpleado/autocomplete/PerfilEmpleadoAutocompleteFormItem';
import PlanificacionAutocompleteFormItem from 'src/view/planificacion/autocomplete/PlanificacionAutocompleteFormItem';
import ProjectAutocompleteFormItem from 'src/view/project/autocomplete/ProjectAutocompleteFormItem';
import Spinner from 'src/view/shared/Spinner';
import CheckboxFormItem from 'src/view/shared/form/items/CheckboxFormItem';
import DatePickerFormItem from 'src/view/shared/form/items/DatePickerFormItem';
import FilesFormItem from 'src/view/shared/form/items/FilesFormItem';
import ImagesFormItem from 'src/view/shared/form/items/ImagesFormItem';
import InputFormItem from 'src/view/shared/form/items/InputFormItem';
import InputMultiSelectorFormItem from 'src/view/shared/form/items/InputMultiSelectorFormItem';
import InputNumberFormItem from 'src/view/shared/form/items/InputNumberFormItem';
import InputSignatureFormItem from 'src/view/shared/form/items/InputSignatureFormItem';
import MultiCheckboxFormItem from 'src/view/shared/form/items/MultiCheckboxFormItem';
import MultiCheckboxTreeFormItem from 'src/view/shared/form/items/MultiCheckboxTreeFormItem';
import SelectFormItem from 'src/view/shared/form/items/SelectFormItem';
import SelectTreeFormItem from 'src/view/shared/form/items/SelectTreeFormItem';
import TextAreaFormItem from 'src/view/shared/form/items/TextAreaFormItem';
import Message from 'src/view/shared/message';
import ImagesViewItem from 'src/view/shared/view/ImagesViewItem';
import TerceroAutocompleteFormItem from 'src/view/tercero/autocomplete/TerceroAutocompleteFormItem';
import UbicacionAutocompleteFormItem from 'src/view/ubicacion/autocomplete/UbicacionAutocompleteFormItem';
import UserAutocompleteFormItem from 'src/view/user/autocomplete/UserAutocompleteFormItem';
import {
  isBlumarSsoTenant,
  isIncidentDateKeyPointer,
  pickerFormatWithSpanishWeekday,
  spanishWeekdayFromDate,
} from 'src/modules/incident/incidentDateWeekday';
import {
  effectiveIncidentAnswerType,
  filterCrushFromInjuryAlternativas,
  isIncidentYesNoKeyPointer,
  seedYesNoFromCheckbox,
} from 'src/modules/incident/incidentFormAnswerCoerce';

const fillT = (template, variables) => {
  return template.replace(/\${(.*?)}/g, (match, variable) => variables[variable]);
};

export default function RespuestaFormularioForm(props) {
  const {item, secciones, preguntaKey, editar = true, validationErrorMessage} = props;
  //console.log('%c⧭ RespuestaFormularioForm', 'color: #364cd9', {item});

  const {control, getValues, register, setValue} = useFormContext();
  const currentTenant = useSelector(authSelectors.selectCurrentTenant);
  const effectiveTipoRespuesta = effectiveIncidentAnswerType(item);

  // useWatch no se puede usar dentro de un foreach
  // const watchNPregunta = useWatch({ name: `${preguntaKey}.nPregunta`, control });
  // const watchTienePuntaje = useWatch({ name: `${preguntaKey}.tienePuntaje`, control });
  // const watchLink = useWatch({ name: `${preguntaKey}.link`, control });
  // const watchTieneComentario = useWatch({ name: `${preguntaKey}.tieneComentario`, control });
  // const watchTipoRespuesta: any = useWatch({ name: `${preguntaKey}.tipoRespuesta`, control });
  // const watchUnidadMedida = useWatch({ name: `${preguntaKey}.unidadMedida`, control });
  // const watchPuntaje = useWatch({ name: `${preguntaKey}.puntaje`, control });
  // const watchRespuestaCorrecta = useWatch({ name: `${preguntaKey}.respuestaCorrecta`, control });
  // const watchAlternativas = useWatch({ name: `${preguntaKey}.alternativas`, control });
  // const watchComentario = getValues(`${preguntaKey}.comentario`);//useWatch({ name: `${preguntaKey}.comentario`, control });
  // const watchRespuesta = useWatch({ name: `${preguntaKey}.respuesta`, control });
  // const watchCheckbox = useWatch({ name: `${preguntaKey}.checkbox`, control });
  // const watchTextField = useWatch({ name: `${preguntaKey}.textField`, control });
  // const watchNumberField = useWatch({ name: `${preguntaKey}.numberField`, control });
  // const watchAmmount = useWatch({ name: `${preguntaKey}.ammount`, control });
  // const watchMultipleChoice = useWatch({ name: `${preguntaKey}.multipleChoice`, control });
  // const watchInspectionCheck = useWatch({ name: `${preguntaKey}.inspectionCheck`, control });
  // const watchYesNo = useWatch({ name: `${preguntaKey}.yesNo`, control });
  // const watchFiles = useWatch({ name: `${preguntaKey}.files`, control });
  // const watchImages = useWatch({ name: `${preguntaKey}.images`, control });
  // const watchSignature = useWatch({ name: `${preguntaKey}.signature`, control });
  // const watchDate = useWatch({ name: `${preguntaKey}.date`, control });
  // const watchTime = useWatch({ name: `${preguntaKey}.time`, control });
  // const watchLocation = useWatch({ name: `${preguntaKey}.location`, control });
  // const watchPerfilEmpleado = useWatch({ name: `${preguntaKey}.perfilEmpleado`, control });
  // const watchMeterReading = useWatch({ name: `${preguntaKey}.meterReading`, control });

  // const watchFields = {
  //   // nPregunta: watchNPregunta,
  //   // tienePuntaje: watchTienePuntaje,
  //   // link: watchLink,
  //   // tieneComentario: watchTieneComentario,
  //   // tipoRespuesta: watchTipoRespuesta,
  //   // unidadMedida: watchUnidadMedida,
  //   // puntaje: watchPuntaje,
  //   // respuestaCorrecta: watchRespuestaCorrecta,
  //   // alternativas: watchAlternativas,
  //   comentario: watchComentario,
  //   // respuesta: watchRespuesta,
  //   checkbox: watchCheckbox,
  //   textField: watchTextField,
  //   numberField: watchNumberField,
  //   ammount: watchAmmount,
  //   multipleChoice: watchMultipleChoice,
  //   inspectionCheck: watchInspectionCheck,
  //   yesNo: watchYesNo,
  //   files: watchFiles,
  //   images: watchImages,
  //   signature: watchSignature,
  //   date: watchDate,
  //   time: watchTime,
  //   location: watchLocation,
  //   perfilEmpleado: watchPerfilEmpleado,
  //   meterReading: watchMeterReading
  // };
  if (item.allowOthersOption) {
    if (item.alternativasCheckbox && item.alternativasCheckbox.slice(-1)[0]?.id !== 'others')
      item.alternativasCheckbox.push({id: 'others', label: 'Otros', value: false});
    if (item.alternativas && item.alternativas.slice(-1)[0]?.id !== 'others')
      item.alternativas.push({label: 'Otros', id: 'others'});
  }

  const alternativasCheckboxTree = Array.isArray(item.alternativasCheckbox) ? item.alternativasCheckbox : [];
  const flattenAlternativasCheckbox = (nodes = [], parentPath = '') => {
    const flat: any = [];
    nodes.forEach((node: any) => {
      const pathLabel = parentPath ? `${parentPath} > ${node.label}` : node.label;
      flat.push({id: node.id, label: pathLabel});
      if (Array.isArray(node.children) && node.children.length) {
        flat.push(...flattenAlternativasCheckbox(node.children, pathLabel));
      }
    });
    return flat;
  };
  const alternativasCheckbox = flattenAlternativasCheckbox(alternativasCheckboxTree);
  const isAlternativasCheckboxTree = alternativasCheckboxTree.some(
    (node) => Array.isArray(node?.children) && node.children.length > 0,
  );
  const multiCheckboxRawValue = Array.isArray(item.multiCheckbox)
    ? item.multiCheckbox
    : Array.isArray(item[item.tipoRespuesta])
      ? item[item.tipoRespuesta]
      : [];
  const preguntaFields = {
    respuestaCorrecta: {default: null},
    alternativas: {default: null},
    alternativasCheckbox: {default: null},
    respuesta: {default: null},
    checkbox: {default: null},
    multiCheckbox: {
      default: multiCheckboxRawValue.length
        ? multiCheckboxRawValue.map((a, i) => ({
            ...a,
            id: alternativasCheckbox?.find((opt) => opt.id === (a?.id ?? alternativasCheckbox?.[i]?.id))?.id ?? a?.id,
            label: alternativasCheckbox?.find((opt) => opt.id === (a?.id ?? alternativasCheckbox?.[i]?.id))?.label ?? a?.label,
            value: Boolean(a?.value),
          }))
        : alternativasCheckbox?.map((a) => {
            return {id: a.id, label: a.label, value: false};
          }),
    },
    textField: {default: null},
    numberField: {default: null},
    ammount: {default: null},
    multipleChoice: {default: null},
    inspectionCheck: {default: 'Aprobado'},
    yesNo: {default: null},
    files: {default: null},
    images: {default: null},
    signature: {default: null},
    date: {default: moment()},
    meterReading: {default: null},
    time: {
      get default() {
        return moment();
      },
    },
    location: {default: null},
    perfilEmpleado: {default: null},
    articulo: {default: null},
    usuario: {default: null},
    thirdParty: {default: null},
    asset: {default: null},
    planificacion: {default: null},
    modeloTarea: {default: null},
    project: {default: null},
  };
  const watchNotApplicable = useWatch({
    name: `${preguntaKey}.notApplicable`,
    control,
    defaultValue: item.notApplicable ?? false,
  });
  const notApplicable = Boolean(item.allowNotApplicable && watchNotApplicable);
  const answerLocked = !editar || notApplicable;

  useEffect(() => {
    register(`${preguntaKey}.comentario`);
    if (item.allowNotApplicable) {
      register(`${preguntaKey}.notApplicable`);
      setValue(`${preguntaKey}.notApplicable`, Boolean(item.notApplicable));
    }
    Object.keys(preguntaFields).forEach((field) => {
      if ([item.tipoRespuesta, effectiveTipoRespuesta].includes(field) && !['files', 'images', 'textFromImage'].includes(field)) {
        register(`${preguntaKey}.${field}`, {required: item.isRequired});

        if ([field, item.tipoRespuesta, effectiveTipoRespuesta].includes('multiCheckbox')) {
          //console.log('%c⧭ value: ' + preguntaKey + '.' + field, 'color: #99614d', {default: preguntaFields[field].default});
          setValue(`${preguntaKey}.${field}`, preguntaFields[field].default);
        } else {
          setValue(`${preguntaKey}.${field}`, item[field] ?? preguntaFields[field].default);
        }
      }
    });
    if (isIncidentYesNoKeyPointer(item.keyPointer)) {
      register(`${preguntaKey}.yesNo`, {required: item.isRequired});
      const seeded = seedYesNoFromCheckbox(item);
      if (seeded != null) {
        setValue(`${preguntaKey}.yesNo`, seeded);
      }
    }
  }, []);

  useEffect(() => {
    if (!item.allowNotApplicable) return;
    register(`${preguntaKey}.${effectiveTipoRespuesta}`, {required: item.isRequired && !notApplicable});
  }, [notApplicable]);

  const onNotApplicableChange = (checked: boolean) => {
    if (!checked) return;
    if (item.tipoRespuesta === 'multiCheckbox') {
      const current = getValues(`${preguntaKey}.multiCheckbox`);
      setValue(
        `${preguntaKey}.multiCheckbox`,
        Array.isArray(current) ? current.map((option) => ({...option, value: false})) : current,
      );
      return;
    }
    setValue(`${preguntaKey}.${effectiveTipoRespuesta}`, null);
    if (effectiveTipoRespuesta !== item.tipoRespuesta) {
      setValue(`${preguntaKey}.${item.tipoRespuesta}`, null);
    }
  };

  useEffect(() => {
    if (!item.defaultFirstOption || notApplicable) return;

    if (item.tipoRespuesta === 'multipleChoice') {
      const hasValue = getValues(`${preguntaKey}.multipleChoice`);
      if (hasValue) return;

      const lastOption = alternativeSelectValue(item.alternativas?.[item.alternativas.length - 1]);
      if (lastOption) {
        setValue(`${preguntaKey}.multipleChoice`, lastOption);
      }
      return;
    }

    if (item.tipoRespuesta === 'multiCheckbox' && alternativasCheckbox.length > 0) {
      const currentValue = getValues(`${preguntaKey}.multiCheckbox`);
      const hasCheckedOption = Array.isArray(currentValue) && currentValue.some((option) => option?.value);
      if (hasCheckedOption) return;

      const lastIdx = alternativasCheckbox.length - 1;
      const defaults = alternativasCheckbox.map((a, idx) => ({
        id: a.id,
        label: a.label,
        value: idx === lastIdx,
      }));
      setValue(`${preguntaKey}.multiCheckbox`, defaults);
    }
  }, [item.defaultFirstOption, item.tipoRespuesta, item.alternativas, alternativasCheckbox, getValues, preguntaKey, setValue, notApplicable]);
  //console.log('%c⧭ preguntaKey', 'color: #f27999', preguntaKey);
  const watchMultiCheckbox = useWatch({
    name: `${preguntaKey}.multiCheckbox`,
    control,
    defaultValue: preguntaFields['multiCheckbox'].default,
  }); //, defaultValue: preguntaFields['multiCheckbox'].default });
  const watchMultipleChoiceValue = useWatch({
    name: `${preguntaKey}.multipleChoice`,
    control,
    defaultValue: item.multipleChoice ?? null,
  });
  const mergedAlternativasMultipleChoice = React.useMemo(
    () =>
      filterCrushFromInjuryAlternativas(
        mergeLiteralIntoAlternativas(item.alternativas, watchMultipleChoiceValue, item.alternativeTree),
        item.keyPointer,
      ),
    [item.alternativas, item.alternativeTree, item.keyPointer, watchMultipleChoiceValue],
  );
  const watchDateValue = useWatch({
    name: `${preguntaKey}.date`,
    control,
    defaultValue: item.date,
  });
  const incidentDateWeekday =
    isBlumarSsoTenant(currentTenant) && isIncidentDateKeyPointer(item.keyPointer)
      ? spanishWeekdayFromDate(watchDateValue || item.date)
      : null;
  //const valuesMultiCheckbox = getValues(`${preguntaKey}.multiCheckbox`);
  //if ([item.tipoRespuesta].includes('multiCheckbox')) console.log('%c⧭ respuesta', 'color: #99614d', {valuesMultiCheckbox, watchMultiCheckbox, item});

  const [loadingReadImage, setLoadingReadImage] = React.useState(false);

  const onAnswerModified = (value) => {
    navigator.geolocation.getCurrentPosition((pos) => {
      const coords = pos.coords;

      Geocode.fromLatLng(coords.latitude, coords.longitude).then(
        (response) => {
          const address = response.results[0].formatted_address;

          setValue(`${preguntaKey}.geolocation`, {
            latitud: coords.latitude,
            longitud: coords.longitude,
            address: address,
          });

          setValue('ultimaUbicacion', {
            latitud: coords.latitude,
            longitud: coords.longitude,
            address: address,
          });
        },
        (error) => {
          console.error(error);
        },
      );
    });
  };

  const applyArticuloToleranceBounds = (articulo) => {
    if (!isPlastyvergTenant(currentTenant?.id)) return;

    const titulo = resolvePlastyvergArticuloTitulo({
      tituloTarea: getValues('tituloTarea'),
      modeloTarea: getValues('modeloTarea'),
    });
    if (!resolvePlastyvergArticuloVariant(titulo)) return;

    const estructura = getValues('estructuraAnidada');
    if (Array.isArray(estructura) && estructura.length) {
      setValue('estructuraAnidada', applyArticuloToleranceBoundsToEstructura(estructura, articulo, titulo));
    }

    const lista = getValues('listaProcedimiento');
    if (Array.isArray(lista) && lista.length) {
      setValue('listaProcedimiento', applyArticuloToleranceBoundsForTask(lista, articulo, titulo));
    }
  };

  useEffect(() => {
    if (item.tipoRespuesta !== 'articulo') return;
    if (!isPlastyvergTenant(currentTenant?.id)) return;

    let cancelled = false;

    const hydrate = async () => {
      const current = getValues(`${preguntaKey}.articulo`) || item.articulo;
      if (!current?.id) return;

      let articulo = current;
      const missingCatalog = current.descripcion == null && current.kgBruto == null && current.codigoArticulo == null;
      if (missingCatalog) {
        try {
          const rows = await ArticuloService.listAutocomplete([current.id], 1);
          const full = rows?.[0];
          if (full && !cancelled) {
            articulo = {...current, ...full};
            setValue(`${preguntaKey}.articulo`, articulo, {shouldDirty: false});
          }
        } catch (error) {
          console.error(error);
          return;
        }
      }

      if (!cancelled) {
        applyArticuloToleranceBounds(articulo);
      }
    };

    hydrate();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const decodeImage = (file): any => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        Quagga.decodeSingle(
          {
            decoder: {
              readers: [
                'code_128_reader',
                {
                  format: 'ean_reader',
                  config: {
                    supplements: ['ean_5_reader', 'ean_2_reader'],
                  },
                },
                'ean_8_reader',
                'code_39_reader',
                'code_39_vin_reader',
                'codabar_reader',
                'upc_reader',
                'upc_e_reader',
                'i2of5_reader',
                '2of5_reader',
                'code_93_reader',
              ], // Change this according to the type of barcode you want to read
            },
            locate: true,
            // @ts-ignore
            src: reader.result,
            numOfWorkers: 0, // Needs to be 0 when used on the client side
            inputStream: {
              size: 800, // restrict input-size to be 800px in width (long-side)
            },
          },
          (result) => {
            //console.log('%c⧭ result', 'color: #994d75', result);
            if (result && result.codeResult) {
              console.log('result', result.codeResult.code);
              resolve(result.codeResult.code);
            } else {
              console.log('not detected');
              resolve(null);
            }
          },
        );
      };
      reader.readAsDataURL(file);
    });
  };

  const readBarcode = async (image, name) => {
    const barcode = await decodeImage(image);
    if (!barcode) {
      Message.error('No se ha detectado un código de barras en la imagen');
    }
    console.log('%c⧭ barcode result', 'color: #00ff88', barcode);
    setValue(name, barcode);
  };

  const barcodeValue = useWatch({name: `${preguntaKey}.barcode`, control});
  const textFromImageValue = useWatch({name: `${preguntaKey}.textFromImage`, control});
  const imageValue = useWatch({name: `${preguntaKey}.image`, control});
  const path = `[${item.pregunta?.label}]`;
  const requiredString = item.isRequired && !notApplicable ? fillT(i18n('validation.string.required'), {path}) : undefined;

  const watchRespuesta = useWatch({
    name: `${preguntaKey}.${item.tipoRespuesta}`,
    control,
    defaultValue: item[item.tipoRespuesta],
  });
  //console.log('watchRespuesta', watchRespuesta, item.tipoRespuesta, item);
  const checkAlertRange = (value) => {
    let isAlert = false;
    if (item.hasAlertNumberRange && item.alertNumberRange?.length > 0 && item.tipoRespuesta === 'numberField') {
      let [min, max] = item.alertNumberRange;
      min = min ? Number(min) : -Infinity;
      max = max ? Number(max) : Infinity;
      isAlert = value >= min && value <= max;
      return item.invertAlertNumberRange ? !isAlert : isAlert;
    }
    return false;
  };
  const checkAlertRangeText = (value) => {
    if (item.hasAlertNumberRange && item.alertNumberRange?.length > 0 && item.tipoRespuesta === 'numberField') {
      let [min, max] = item.alertNumberRange;
      if (min && !max) {
        return item.invertAlertNumberRange ? `* Alerta: Número menor a ${min}` : `* Alerta: Número mayor a ${min}`;
      }
      if (!min && max) {
        return item.invertAlertNumberRange ? `* Alerta: Número mayor a ${max}` : `* Alerta: Número menor a ${max}`;
      }
      min = min ? Number(min) : -Infinity;
      max = max ? Number(max) : Infinity;
      if (value >= min && value <= max) {
        return !item.invertAlertNumberRange ? '* Alerta: Número en rango [' + min + ' a ' + max + ']' : '';
      } else if (item.invertAlertNumberRange) {
        return '* Alerta: Número fuera de rango [' + min + ' a ' + max + ']';
      }
    }
    return '';
  };

  const getNumericBound = (value: any) => {
    if (value === null || value === undefined || value === '') {
      return undefined;
    }
    const numeric = Number(value);
    return Number.isNaN(numeric) ? undefined : numeric;
  };

  const normalizeAlternativeTree = (alt) => {
    return {
      value: alternativeSelectValue(alt),
      label: alt.label,
      children:
        Array.isArray(alt.children) && alt.children.length > 0
          ? alt.children.map((child) => normalizeAlternativeTree(child))
          : [],
    };
  };

  if (item?.isTaskExecutorFromSource) {
    return null;
  }

  return (
    secciones && (
      <Grid container direction="column">
        <Grid item pb={notApplicable ? 0 : 2}>
          <Box display="flex" alignItems="center" justifyContent="space-between" gap={2} width="100%">
            <Typography variant="h4" sx={{flex: 1, minWidth: 0, pr: 1}}>
              {item.nPregunta + ') '} {item.pregunta?.titulo || item.pregunta?.label}{' '}
              {item.puntaje ? ' (' + item.puntaje + ' Puntos)' : null}
            </Typography>
            {item.allowNotApplicable && (
              <Box sx={{flexShrink: 0}}>
                <CheckboxFormItem
                  label={i18n('common.notApplicable')}
                  name={`${preguntaKey}.notApplicable`}
                  disabled={!editar}
                  onChange={onNotApplicableChange}
                />
              </Box>
            )}
          </Box>
          {!notApplicable && validationErrorMessage && (
            <Typography variant="body2" color="error" sx={{mt: 1, display: 'block', fontWeight: 500}}>
              {validationErrorMessage}
            </Typography>
          )}
          {/*<PreguntaViewPage id={item.pregunta?.id} image={true} />*/}
        </Grid>
        {!notApplicable && (
        <Grid item>
          <Grid
            container
            direction="column"
            sx={{
              pl: item.nPregunta > 9 ? 3.5 : 2.5,
            }}>
            {(item.pregunta?.foto?.length > 0 || item.pregunta?.photo?.length > 0) && (
              <Grid item>
                <ImagesViewItem value={item.pregunta.foto || item.pregunta.photo} />
              </Grid>
            )}

            {item.pregunta?.descripcion && (
              <Grid item pb={1}>
                <Typography
                  component="pre"
                  variant="subtitle2"
                  sx={{
                    fontWeight: 'inherit',
                    fontSize: 'inherit',
                    fontFamily: 'inherit',
                    whiteSpace: 'pre-wrap',
                  }}>
                  {item.pregunta?.descripcion}
                </Typography>
              </Grid>
            )}
            {item.link && item.link !== 'Si' && (
              <Grid item pb={1}>
                <Link
                  sx={{textDecoration: 'none'}}
                  target="_blank"
                  href={item.link}
                  component={(props) => <Button {...props} variant="outlined" />}>
                  Abrir Enlace Adjunto
                </Link>
              </Grid>
            )}

            <Grid item pt={1}>
              <Typography variant="caption">Respuesta</Typography>
            </Grid>
            <Grid item>
              {effectiveTipoRespuesta === 'checkbox' && (
                <Box
                  sx={{
                    mt: -1,
                    ml: -1,
                  }}>
                  <CheckboxFormItem
                    onChange={onAnswerModified}
                    name={`${preguntaKey}.checkbox`}
                    disabled={answerLocked}
                    size="large"
                    required={requiredString}
                  />
                </Box>
              )}
              {item.tipoRespuesta === 'multiCheckbox' && Array.isArray(watchMultiCheckbox) && item.alternativasCheckbox && (
                <>
                  {isAlternativasCheckboxTree ? (
                    <MultiCheckboxTreeFormItem
                      name={`${preguntaKey}.multiCheckbox`}
                      nameOthers={`${preguntaKey}.multiCheckboxOthers`}
                      allowOthersOption={item.allowOthersOption}
                      onlyOneOption={item.onlyOneOption}
                      optionsTree={alternativasCheckboxTree}
                      onChange={onAnswerModified}
                      disabled={answerLocked}
                      required={requiredString}
                    />
                  ) : (
                    <MultiCheckboxFormItem
                      name={`${preguntaKey}.multiCheckbox`}
                      nameOthers={`${preguntaKey}.multiCheckboxOthers`}
                      allowOthersOption={item.allowOthersOption}
                      onlyOneOption={item.onlyOneOption}
                      defaultValue={
                        watchMultiCheckbox ||
                        alternativasCheckbox.map((a) => {
                          return {id: a.id, label: a.label, value: false};
                        })
                      }
                      onChange={onAnswerModified}
                      disabled={answerLocked}
                      required={requiredString}
                    />
                  )}
                </>
              )}

              {item.tipoRespuesta === 'multipleChoice'
                ? mergedAlternativasMultipleChoice &&
                  mergedAlternativasMultipleChoice.length > 0 && (
                    <SelectTreeFormItem
                      menuPortalTarget={document.body}
                      name={`${preguntaKey}.multipleChoice`}
                      nameOthers={`${preguntaKey}.multipleChoiceOthers`}
                      allowOthersOption={item.allowOthersOption}
                      disabled={answerLocked}
                      label={!editar ? '' : i18n('common.selectOption')}
                      alternativeTreePregunta={item}
                      pathDisplayViewKey="disabledInput"
                      options={
                        Array.isArray(mergedAlternativasMultipleChoice)
                          ? mergedAlternativasMultipleChoice.map((alt) => normalizeAlternativeTree(alt))
                          : []
                      }
                      required={requiredString}
                      onChange={onAnswerModified}
                    />
                  )
                : item.alternativas?.filter((alt) => item.respuesta === alt.id && item.respuestaCorrecta?.id === item.respuesta)
                      .length > 0
                  ? item.alternativas
                      ?.filter((alt) => item.respuesta === alt.id && item.respuestaCorrecta?.id === item.respuesta)
                      .map((res) => (
                        <h2>
                          <Check style={{color: 'green', marginRight: 10}} /> {res.label}{' '}
                        </h2>
                      ))
                  : item.alternativas
                      ?.filter((alt) => item.respuesta === alt.id)
                      .map((res) => (
                        <h2>
                          <Close style={{color: 'red', marginRight: 10}} /> {res.label}
                        </h2>
                      ))}

              {item.tipoRespuesta === 'textField' &&
                ((!loadingReadImage && (
                  <TextAreaFormItem
                    disabled={answerLocked}
                    label={!editar ? '' : i18n('common.enterAnswer')}
                    name={`${preguntaKey}.textField`}
                    onChange={onAnswerModified}
                    required={Boolean(requiredString)}
                  />
                )) ||
                  (loadingReadImage && (
                    <Box>
                      <Typography variant="caption">Leyendo imagen...</Typography>
                      <Spinner />
                    </Box>
                  )))}

              {item.tipoRespuesta === 'numberField' && (
                <>
                  <InputNumberFormItem
                    disabled={answerLocked}
                    label={!editar ? '' : i18n('common.enterAnswer')}
                    name={`${preguntaKey}.numberField`}
                    onChange={onAnswerModified}
                    required={requiredString}
                    min={getNumericBound(item.numberFieldMin)}
                    max={getNumericBound(item.numberFieldMax)}
                  />
                  {checkAlertRange(watchRespuesta) && (
                    <Box mt={1}>
                      <Typography color="red">{checkAlertRangeText(watchRespuesta)}</Typography>
                    </Box>
                  )}
                </>
              )}

              {item.tipoRespuesta === 'ammount' && (
                <InputNumberFormItem
                  onChange={onAnswerModified}
                  disabled={answerLocked}
                  label={!editar ? '' : i18n('common.enterAmount')}
                  name={`${preguntaKey}.ammount`}
                  required={requiredString}
                  min={getNumericBound(item.ammountMin)}
                  max={getNumericBound(item.ammountMax)}
                />
              )}

              {/* TODO: Validar rut */}
              {item.tipoRespuesta === 'registrationNumber' && (
                <InputFormItem
                  onChange={onAnswerModified}
                  disabled={answerLocked}
                  label={!editar ? '' : i18n('common.enterRegistrationNumber')}
                  name={`${preguntaKey}.registrationNumber`}
                  required={requiredString}
                />
              )}

              {item.tipoRespuesta === 'inspectionCheck' && (
                <InputMultiSelectorFormItem
                  onChange={onAnswerModified}
                  options={[
                    {
                      value: 'Aprobado',
                      label: 'Aprobado',
                      color: 'green',
                    },
                    {
                      value: 'Observado',
                      label: 'Observado',
                      color: 'orange',
                    },
                    {
                      value: 'Rechazado',
                      label: 'Rechazado',
                      color: 'red',
                    },
                  ]}
                  disabled={answerLocked}
                  //label={!editar ? 'Respuesta' : 'Ingrese Estado'}
                  name={`${preguntaKey}.inspectionCheck`}
                  required={requiredString}
                />
              )}

              {effectiveTipoRespuesta === 'yesNo' && (
                <SelectFormItem
                  onChange={onAnswerModified}
                  disabled={answerLocked}
                  name={`${preguntaKey}.yesNo`}
                  defaultValue={item.yesNo ?? seedYesNoFromCheckbox(item)}
                  menuPortalTarget={document.body}
                  label={!editar ? '' : i18n('common.enterAlternative')}
                  options={[
                    {
                      value: 'Si',
                      label: 'Si',
                    },
                    {
                      value: 'No',
                      label: 'No',
                    },
                    {
                      value: 'N/A',
                      label: 'N/A',
                    },
                  ]}
                  required={requiredString}
                />
              )}

              {item.tipoRespuesta === 'barcode' && (
                <Box mt={'2px'}>
                  {editar && (
                    <ImagesFormItem
                      onImageUpload={(imgFile) => readBarcode(imgFile, `${preguntaKey}.barcode`)}
                      name={`${preguntaKey}.barcodeImage`}
                      label={i18n('common.barcodeImage')}
                      required={requiredString}
                      storage={Storage.values.tareaFotosEnviadas}
                      max={1}
                    />
                  )}
                  <Box display="flex" flexDirection="row" alignItems="flex-end" gap={2}>
                    <Box sx={{width: 'fit-content'}}>
                      <InputFormItem
                        onChange={onAnswerModified}
                        name={`${preguntaKey}.barcode`}
                        disabled={true}
                        label={i18n('common.barcode')}
                        required={requiredString}
                      />
                    </Box>
                    {barcodeValue && (
                      <Box sx={{mb: 1, width: '26px', height: '26px'}}>
                        <Check style={{color: 'green'}} />
                      </Box>
                    )}
                  </Box>
                </Box>
              )}

              {item.tipoRespuesta === 'textFromImage' && (
                <Box mt={'2px'}>
                  {imageValue?.[0]?.upload === false && !textFromImageValue && (
                    <Typography variant="caption">Imagen no se ha sincronizado con el servidor</Typography>
                  )}
                  {imageValue?.[0]?.downloadUrl && !textFromImageValue && (
                    <Typography variant="caption">Texto pendiente de ser detectado en la imagen</Typography>
                  )}
                  {textFromImageValue && (
                    <Typography
                      variant={'subtitle2'}
                      sx={{
                        fontWeight: 500,
                        fontSize: '1.15em',
                      }}>
                      {textFromImageValue}
                    </Typography>
                  )}
                  <ImagesFormItem
                    onChange={onAnswerModified}
                    name={`${preguntaKey}.image`}
                    label={!editar ? i18n('common.addedImages') : i18n('common.addImages')}
                    required={requiredString}
                    storage={Storage.values.tareaFotosEnviadas}
                    disabled={answerLocked}
                    AIContent
                    max={1}
                  />
                </Box>
              )}

              {item.tipoRespuesta === 'files' && (
                <Box mt={'2px'}>
                  {!item.imagesOnly && (
                    <FilesFormItem
                      onChange={onAnswerModified}
                      name={`${preguntaKey}.files`}
                      required={requiredString}
                      label={!editar ? i18n('common.addedDocuments') : i18n('common.addDocuments')}
                      storage={Storage.values.tareaDocumentosEnviados}
                      max={undefined}
                      disabled={answerLocked}
                      formats={undefined}
                    />
                  )}
                  <ImagesFormItem
                    onChange={onAnswerModified}
                    name={`${preguntaKey}.images`}
                    label={!editar ? i18n('common.addedPhotos') : i18n('common.addPhotos')}
                    required={requiredString}
                    storage={Storage.values.tareaFotosEnviadas}
                    disabled={answerLocked}
                    AIContent
                    //max={3}
                  />
                </Box>
              )}

              {item.tipoRespuesta === 'signature' && (
                <InputSignatureFormItem
                  onChange={onAnswerModified}
                  name={`${preguntaKey}.signature`}
                  signatureRefName={`${preguntaKey}.signatureRef`}
                  label={!editar ? '' : i18n('common.enterSignature')}
                  disabled={answerLocked}
                  storage={Storage.values.tareaFotosEnviadas}
                  width={window.innerWidth > 768 ? 500 : 280}
                  height={300}
                  required={requiredString}
                />
              )}

              {item.tipoRespuesta === 'day' && (
                <SelectFormItem
                  onChange={onAnswerModified}
                  name={`${preguntaKey}.day`}
                  disabled={answerLocked}
                  menuPortalTarget={document.body}
                  label={!editar ? '' : i18n('common.selectDay')}
                  options={[
                    {
                      value: 'monday',
                      label: 'Lunes',
                    },
                    {
                      value: 'tuesday',
                      label: 'Martes',
                    },
                    {
                      value: 'wednesday',
                      label: 'Miercoles',
                    },
                    {
                      value: 'thursday',
                      label: 'Jueves',
                    },
                    {
                      value: 'friday',
                      label: 'Viernes',
                    },
                    {
                      value: 'saturday',
                      label: 'Sabado',
                    },
                    {
                      value: 'sunday',
                      label: 'Domingo',
                    },
                  ]}
                  required={requiredString}
                />
              )}

              {item.tipoRespuesta === 'month' && (
                <SelectFormItem
                  onChange={onAnswerModified}
                  name={`${preguntaKey}.month`}
                  disabled={answerLocked}
                  menuPortalTarget={document.body}
                  label={!editar ? '' : i18n('common.selectMonth')}
                  options={[
                    {
                      value: 'january',
                      label: 'Enero',
                    },
                    {
                      value: 'february',
                      label: 'Febrero',
                    },
                    {
                      value: 'march',
                      label: 'Marzo',
                    },
                    {
                      value: 'april',
                      label: 'Abril',
                    },
                    {
                      value: 'may',
                      label: 'Mayo',
                    },
                    {
                      value: 'june',
                      label: 'Junio',
                    },
                    {
                      value: 'july',
                      label: 'Julio',
                    },
                    {
                      value: 'august',
                      label: 'Agosto',
                    },
                    {
                      value: 'september',
                      label: 'Septiembre',
                    },
                    {
                      value: 'october',
                      label: 'Octubre',
                    },
                    {
                      value: 'november',
                      label: 'Noviembre',
                    },
                    {
                      value: 'december',
                      label: 'Diciembre',
                    },
                  ]}
                  required={requiredString}
                />
              )}

              {item.tipoRespuesta === 'date' && (
                <DatePickerFormItem
                  onChange={onAnswerModified}
                  minDate={item.allowDateBefore ? undefined : moment().toISOString()}
                  disabled={answerLocked}
                  name={`${preguntaKey}.date`}
                  defaultValue={item.date || moment()}
                  label={!editar ? '' : i18n('common.selectDate')}
                  required={requiredString}
                  format={pickerFormatWithSpanishWeekday('DD-MM-YYYY', incidentDateWeekday)}
                  momentFormat={pickerFormatWithSpanishWeekday('DD-MM-YYYY', incidentDateWeekday)}
                />
              )}

              {item.tipoRespuesta === 'time' && (
                <DatePickerFormItem
                  onChange={onAnswerModified}
                  disabled={answerLocked}
                  name={`${preguntaKey}.time`}
                  defaultValue={item.time || moment()}
                  label={!editar ? '' : i18n('common.selectTime')}
                  required={requiredString}
                  {...{timeOnly: true}}
                />
              )}

              {item.tipoRespuesta === 'location' && (
                <UbicacionAutocompleteFormItem
                  onChange={onAnswerModified}
                  filter={{restrictByLocation: item.restrictByLocation || 0}}
                  disabled={answerLocked}
                  defaultValue={item.location}
                  name={`${preguntaKey}.location`}
                  size={'large'}
                  label={!editar ? '' : i18n('common.selectLocation')}
                  //onChange={(value) => setValue(`${name}.location`, value)}
                  required={requiredString}
                  showCreate={false}
                  mode={item.isMultiple ? 'multiple' : undefined}
                  menuPortalTarget={document.body}
                />
              )}

              {item.tipoRespuesta === 'perfilEmpleado' && (
                <PerfilEmpleadoAutocompleteFormItem
                  onChange={onAnswerModified}
                  filter={{restrictByLocation: item.restrictByLocation || undefined}}
                  disabled={answerLocked}
                  defaultValue={item.perfilEmpleado}
                  name={`${preguntaKey}.perfilEmpleado`}
                  size={'large'}
                  label={!editar ? '' : i18n('common.selectEmployee')}
                  required={requiredString}
                  showCreate={false}
                  mode={item.isMultiple ? 'multiple' : undefined}
                  menuPortalTarget={document.body}
                />
              )}

              {item.tipoRespuesta === 'articulo' && (
                <ArticuloAutocompleteFormItem
                  onChange={(value) => {
                    onAnswerModified(value);
                    applyArticuloToleranceBounds(value);
                  }}
                  disabled={answerLocked}
                  defaultValue={item.articulo}
                  name={`${preguntaKey}.articulo`}
                  size={'large'}
                  label={!editar ? '' : i18n('common.selectArticulo')}
                  required={requiredString}
                  showCreate={false}
                  menuPortalTarget={document.body}
                />
              )}

              {item.tipoRespuesta === 'usuario' && (
                <UserAutocompleteFormItem
                  onChange={onAnswerModified}
                  filter={{restrictByLocation: item.restrictByLocation || undefined}}
                  disabled={answerLocked}
                  defaultValue={item.usuario}
                  name={`${preguntaKey}.usuario`}
                  size={'large'}
                  label={!editar ? '' : i18n('common.selectUser')}
                  required={requiredString}
                  showCreate={false}
                  mode={item.isMultiple ? 'multiple' : undefined}
                  menuPortalTarget={document.body}
                />
              )}

              {item.tipoRespuesta === 'asignadorFuncion' && (
                <AsignadorFuncionAutocompleteFormItem
                  onChange={onAnswerModified}
                  disabled={answerLocked}
                  defaultValue={item.asignadorFuncion}
                  name={`${preguntaKey}.asignadorFuncion`}
                  size={'large'}
                  label={!editar ? '' : i18n('common.selectTeam')}
                  required={requiredString}
                  showCreate={false}
                  mode={item.isMultiple ? 'multiple' : undefined}
                  menuPortalTarget={document.body}
                />
              )}

              {item.tipoRespuesta === 'asset' && (
                <ActivoAutocompleteFormItem
                  onChange={onAnswerModified}
                  filter={{grupo: 'Equipo', restrictByLocation: item.restrictByLocation || 0}}
                  disabled={answerLocked}
                  defaultValue={item.asset}
                  name={`${preguntaKey}.asset`}
                  size={'large'}
                  label={!editar ? '' : i18n('common.selectAsset')}
                  required={requiredString}
                  showCreate={false}
                  mode={item.isMultiple ? 'multiple' : undefined}
                  menuPortalTarget={document.body}
                />
              )}

              {item.tipoRespuesta === 'planificacion' && (
                <PlanificacionAutocompleteFormItem
                  onChange={onAnswerModified}
                  disabled={answerLocked}
                  defaultValue={item.planificacion}
                  name={`${preguntaKey}.planificacion`}
                  size={'large'}
                  label={!editar ? '' : i18n('entities.planificacion.list.title')}
                  required={requiredString}
                  showCreate={false}
                  mode={item.isMultiple ? 'multiple' : undefined}
                  menuPortalTarget={document.body}
                />
              )}

              {item.tipoRespuesta === 'modeloTarea' && (
                <ModeloTareaAutocompleteFormItem
                  onChange={onAnswerModified}
                  disabled={answerLocked}
                  defaultValue={item.modeloTarea}
                  name={`${preguntaKey}.modeloTarea`}
                  size={'large'}
                  label={!editar ? '' : i18n('entities.modeloTarea.list.title')}
                  required={requiredString}
                  showCreate={false}
                  mode={item.isMultiple ? 'multiple' : undefined}
                  menuPortalTarget={document.body}
                />
              )}

              {item.tipoRespuesta === 'thirdParty' && (
                <TerceroAutocompleteFormItem
                  onChange={onAnswerModified}
                  filter={{restrictByLocation: item.restrictByLocation || 0}}
                  disabled={answerLocked}
                  defaultValue={item.thirdParty}
                  name={`${preguntaKey}.thirdParty`}
                  size={'large'}
                  label={!editar ? '' : i18n('common.selectThirdParty')}
                  required={requiredString}
                  showCreate={false}
                  mode={item.isMultiple ? 'multiple' : undefined}
                  menuPortalTarget={document.body}
                />
              )}

              {item.tipoRespuesta === 'project' && (
                <ProjectAutocompleteFormItem
                  onChange={onAnswerModified}
                  filter={{
                    restrictByLocation: item.restrictByLocation || 0,
                    locations: item.restrictByLocation
                      ? (getValues('listaProcedimiento') || [])
                          .filter((entry) => entry?.tipo === 'pregunta' && entry?.tipoRespuesta === 'location' && entry.location)
                          .flatMap((entry) => (Array.isArray(entry.location) ? entry.location : [entry.location]))
                          .map((loc) => loc?.id || loc?._id)
                          .filter(Boolean)
                      : undefined,
                  }}
                  disabled={answerLocked}
                  defaultValue={item.project}
                  name={`${preguntaKey}.project`}
                  size={'large'}
                  label={!editar ? '' : i18n('common.selectProject')}
                  required={requiredString}
                  showCreate={false}
                  mode={item.isMultiple ? 'multiple' : undefined}
                  menuPortalTarget={document.body}
                />
              )}

              {item.tipoRespuesta === 'meterReading' && (
                <InputNumberFormItem
                  onChange={onAnswerModified}
                  disabled={answerLocked}
                  label={!editar ? '' : i18n('common.enterMeasurement')}
                  name={`${preguntaKey}.meterReading`}
                  required={requiredString}
                />
              )}

              {item.tipoRespuesta === 'year' && (
                <InputNumberFormItem
                  onChange={(value) => {
                    if (value > 9999) {
                      let croppedValue = value.toString().substring(0, 4);
                      setValue(`${preguntaKey}.year`, Number(croppedValue));
                    }
                    if (value < 0) {
                      setValue(`${preguntaKey}.year`, 0);
                    }
                    onAnswerModified(value);
                  }}
                  min={0}
                  disabled={answerLocked}
                  label={!editar ? '' : i18n('common.enterYear')}
                  name={`${preguntaKey}.year`}
                  disableFormat={true}
                  required={requiredString}
                />
              )}
            </Grid>

            {item.haveCriticality && (
              <Grid item pb={1}>
                <Typography variant="caption">{i18n('common.criticalityLevel')}</Typography>
                <InputMultiSelectorFormItem
                  onChange={onAnswerModified}
                  options={[
                    {
                      value: 'Baja',
                      label: i18n('entities.tarea.enumerators.prioridad.Baja'),
                      color: 'green',
                    },
                    {
                      value: 'Media',
                      label: i18n('entities.tarea.enumerators.prioridad.Media'),
                      color: 'orange',
                    },
                    {
                      value: 'Alta',
                      label: i18n('entities.tarea.enumerators.prioridad.Alta'),
                      color: 'red',
                    },
                  ]}
                  disabled={answerLocked}
                  name={`${preguntaKey}.criticality`}
                  required={requiredString}
                />
              </Grid>
            )}

            {(item.tieneComentario || item.comentario) &&
              (editar ? (
                <Grid item sx={{pb: 1}}>
                  <Typography variant="caption">{item.commentLabel || i18n('common.additionalComments')}</Typography>
                  <TextAreaFormItem
                    onChange={onAnswerModified}
                    name={`${preguntaKey}.comentario`}
                    defaultValue={item.comentario}
                    placeholder={i18n('common.enterCommentPlaceholder')}
                  />
                </Grid>
              ) : (
                item.comentario && (
                  <Grid item sx={{pb: 1}}>
                    <Typography variant="caption">{item.commentLabel || i18n('common.additionalComments')}</Typography>
                    <Box sx={{p: 1, border: '1px solid lightgray', borderRadius: '5px'}}>
                      <Typography variant="subtitle1">{item.comentario}</Typography>
                    </Box>
                  </Grid>
                )
              ))}

            {((editar && item.havePhotos) || item.additionalPhotos?.length > 0) && (
              <Grid item>
                <Typography variant="caption">{i18n('common.additionalPhotos')}</Typography>
                <ImagesFormItem
                  onChange={onAnswerModified}
                  name={`${preguntaKey}.additionalPhotos`}
                  label={!editar ? '' : i18n('common.addPhotos')}
                  required={false}
                  storage={Storage.values.tareaFotosEnviadas}
                  disabled={answerLocked || loadingReadImage}
                  AIContent
                  //max={3}
                />
              </Grid>
            )}

            {((editar && item.haveFiles) || item.additionalFiles?.length > 0) && (
              <Grid item>
                <Typography variant="caption">{i18n('common.additionalDocuments')}</Typography>
                <FilesFormItem
                  onChange={onAnswerModified}
                  name={`${preguntaKey}.additionalFiles`}
                  required={false}
                  label={!editar ? '' : i18n('common.addDocuments')}
                  storage={Storage.values.tareaDocumentosEnviados}
                  max={undefined}
                  disabled={answerLocked}
                  formats={undefined}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
        )}
      </Grid>
    )
  );
}
